
const userEvaluation = [
  {
    path: '/user-evaluation',
    name: 'userEvaluation',
    component: () => import('@/views/wxapp/user-evaluation'),
    meta: {
      title: '用户离店评价'
    }
  }
]
export default userEvaluation
